module.exports = __webpack_public_path__ + "img/NL222.167cd055.png";